// extracted by mini-css-extract-plugin
export default {"InputTextFieldComponent":"InputTextFieldComponent_Y3r0H"};